// AUTO-GENERATED at build time by scripts/genBuildInfo.js — do not edit.
export const BUILD_DATE = '2026-09-08';
export const BUILD_TIME = '17:24';
export const BUILD_COMMIT = '7666d01';
